export const SET_ADDING_EMAIL = "SET_ADDING_EMAIL";
export const RESET_ADDING_EMAIL = "RESET_ADDING_EMAIL";
